import { Assets, Container /*, Graphics, Text, TextStyle*/, Graphics, Sprite } from "pixi.js";



export class LoaderScene extends Container {
    public loaderBar: Container = new Container();

    private loaderBarBorder: Sprite | null = null;
    private loaderBarFill: Sprite | null = null;

    private loaderBarFillMask: Graphics | null = null;  // Only used to mask the loader bar fill to avoid the overflow
    private loaderBarFillWidth: number = 0;     // Storing the max width of the loader bar fill

    private studioName: Sprite | null = null;
    private logo: Sprite | null = null;
    private companyName: Sprite | null = null;

    // public continueButton: Graphics = new Graphics();
    // public continueButtonContainer: Container = new Container();
    // private continueButtonWidth: number = 150;
    // private continueButtonHeight: number = 50;


    private background: Container = new Container();



    private screenWidth: number = 0;
    private screenHeight: number = 0;

    constructor() {
        super();
        // this.setupBackground();
        // this.setupContinueButton();
    }

    // private setupBackground(): void {

    //     this.addChild(this.background);
    // }

    private backgroundImage: Sprite;
    public async showInitLogo(screenWidth: number, screenHeight: number) {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        await Assets.load([
            { alias: 'studioName', src: 'assets/desktop/1_loading/nownow_gaming.webp' },
            { alias: 'logo', src: 'assets/desktop/1_loading/logo.webp' },
            { alias: 'loadingBg', src: 'assets/desktop/1_loading/loading_bg.webp' },
            { alias: 'loadingBar', src: 'assets/desktop/1_loading/loading_bar.webp' },
            { alias: 'loadingFill', src: 'assets/desktop/1_loading/loading_fill.webp' },
            { alias: 'companyName', src: 'assets/desktop/1_loading/hacksaw.webp' },
        ]);


        this.backgroundImage = Sprite.from('loadingBg');
        // const blurFilter = new BlurFilter();
        // blurFilter.strength = 10;
        // this.backgroundImage.filters = [blurFilter];

        this.addChild(this.backgroundImage);

        this.addChild(this.background);

        this.studioName = Sprite.from('studioName');
        this.studioName.anchor = 0.5;
        this.studioName.position.set(1500, 1050);

        this.background.addChild(this.studioName);



        this.logo = Sprite.from('logo');
        this.logo.anchor = 0.5;
        this.logo.position.set(1500, 1455);

        this.background.addChild(this.logo);



        this.loaderBarBorder = Sprite.from("loadingBar");
        this.loaderBarFill = Sprite.from("loadingFill");
        // this.loaderBarFill.scale.x = 0;

        this.loaderBarFill.position.set(67, 36);//57, 44);

        // Store the maximum width for the fill
        this.loaderBarFillWidth = this.loaderBarFill.width;

        // Create mask for the fill
        this.loaderBarFillMask = new Graphics();
        this.loaderBarFillMask.position.set(67, 36); // Same position as fill

        // this.loaderBarFill.y = this.loaderBarBorder.height / 2 - this.loaderBarFill.height / 2 ;

        this.loaderBar.addChild(this.loaderBarBorder);
        this.loaderBar.addChild(this.loaderBarFillMask);
        this.loaderBar.addChild(this.loaderBarFill);

        this.loaderBarFill.mask = this.loaderBarFillMask;   // Apply mask to the fill

        this.loaderBar.pivot.set(this.loaderBar.width / 2, this.loaderBar.height / 2)
        this.loaderBar.position.set(1500, 1820);
        this.background.addChild(this.loaderBar);


        // this.continueButtonContainer.pivot.set(this.continueButtonContainer.width/2, this.continueButtonContainer.height/2)
        // this.continueButtonContainer.position.set(1500,1896);
        // this.background.addChild(this.continueButtonContainer);


        this.companyName = Sprite.from('companyName');
        this.companyName.anchor = 0.5;
        this.companyName.position.set(1500, 1950);

        this.background.addChild(this.companyName);

        this.resize(this.screenWidth, this.screenHeight);

    }

    public downloadProgress = (progressRatio: number): void => {

        // if (this.loaderBarFill) {
        //     this.loaderBarFill.scale.x = progressRatio;
        // }

        if (this.loaderBarFillMask && this.loaderBarFill) {
            // Clear and redraw the mask with new width
            this.loaderBarFillMask.clear();

            const currentWidth = this.loaderBarFillWidth * progressRatio;

            // Draw rectangle mask from left to right
            this.loaderBarFillMask.rect(0, 0, currentWidth, this.loaderBarFill.height);
            this.loaderBarFillMask.fill(0xFFFFFF);
        }
    }

    public resize(screenWidth: number, screenHeight: number): void {
        if (!this.background || !this.backgroundImage) {
            console.warn("Resize called before background is initialized");
            return;
        }

        console.log(`loder resize screenWidth${screenWidth} screenHeight ${screenHeight}`);

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        let scale: number;
        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / 1920, screenHeight / 1920);

        if (screenWidth > screenHeight) {

            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.background.scale.set(scale, scale);
            const xPos = (1920 * scale - this.screenWidth) / 2;
            const yPos = (1920 * scale - this.screenHeight) / 2;
            this.background.x = -xPos;
            this.background.y = -yPos;

            this.backgroundImage.scale.set(bgScale, bgScale)
            const bgXPos = (1920 * bgScale - screenWidth) / 2;
            const bgYPos = (1920 * bgScale - screenHeight) / 2;
            this.backgroundImage.position.set(-bgXPos, -bgYPos);

            this.studioName.position.set(960, 540);
            this.studioName.scale = 1;
            this.logo.position.set(929, 880);//(960, 960);
            this.logo.scale = 1;
            // this.loaderBarFill.position.set(22, 10);
            // this.loaderBarFill.scale = 1;
            this.loaderBar.position.set(960, 1270);
            this.loaderBar.scale = 1;
            this.companyName.position.set(960, 1405);
            this.companyName.scale = 1;

        }
        else {

            scale = Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);


            this.background.scale.set(scale, scale);
            const xPos = (1920 * scale - this.screenWidth) / 2;
            const yPos = (1920 * scale - this.screenHeight) / 2;
            this.background.x = -xPos;
            this.background.y = -yPos;

            this.backgroundImage.scale.set(bgScale, bgScale)
            const bgXPos = (1920 * bgScale - screenWidth) / 2;
            const bgYPos = (1920 * bgScale - screenHeight) / 2;
            this.backgroundImage.position.set(-bgXPos, -bgYPos);

            this.studioName.position.set(960, 300);
            this.studioName.scale = 1.5;
            this.logo.position.set(930, 820);
            this.logo.scale = 1.5;
            // this.loaderBarFill.position.set(22, 8);
            // this.loaderBarFill.scale = 1.5;
            this.loaderBar.position.set(960, 1450);
            this.loaderBar.scale = 1.5;
            this.companyName.position.set(960, 1650);
            this.companyName.scale = 1.5;

        }
    }

}
